<div class="sell-us">
    <div class="sell-us__phone">
        <p>{{"about-us.sell-us-call" | translate}}<a href="tel:+48515499875"> +48515499875</a></p>
    </div>
    <div class="sell-us__text">
        {{"about-us.sell-us-text" | translate}}
    </div>
</div>